import React, { useRef, useEffect, useState } from 'react';

export default function ImageCaptcha({ length = 6, onSuccess = () => { }, onFailure = () => { }, width = 220, height = 80 }) {
  const canvasRef = useRef(null);
  const [answer, setAnswer] = useState('');
  const [code, setCode] = useState('');
  const [input, setInput] = useState('');
  const [attempts, setAttempts] = useState(0);
  const [message, setMessage] = useState('');
  const [messageColor, setMessageColor] = useState('');

  // Helper: generate random alphanumeric string
  function randomString(n) {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789'; // removed similar chars 0,O,1,l
    let s = '';
    for (let i = 0; i < n; i++) s += chars.charAt(Math.floor(Math.random() * chars.length));
    return s;
  }

  // Draw captcha to canvas
  function drawCaptcha(text) {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    // clear
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // background gradient
    const grad = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
    grad.addColorStop(0, '#e9eef6');
    grad.addColorStop(1, '#e9eef6');
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // add random lines
    for (let i = 0; i < 6; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineWidth = 1 + Math.random() * 1.5;
      ctx.strokeStyle = `rgba(0,0,0,${0.05 + Math.random() * 0.2})`;
      ctx.stroke();
    }

    const fonts = ['24px Arial', '26px Georgia', '25px Verdana', '26px Tahoma', '24px "Times New Roman"'];
    const padding = 14;
    const availableWidth = canvas.width - padding * 2;
    const letterWidth = availableWidth / text.length;

    for (let i = 0; i < text.length; i++) {
      const ch = text[i];
      const x = padding + i * letterWidth + (Math.random() - 0.5) * 6;
      const y = canvas.height / 2 + (Math.random() - 0.5) * 12 + 10;
      ctx.save();
      const angle = (Math.random() - 0.5) * 0.6; // -0.3 to 0.3 rad
      ctx.translate(x, y);
      ctx.rotate(angle);

      ctx.font = fonts[Math.floor(Math.random() * fonts.length)];
      ctx.fillStyle = `rgba(${50 + Math.floor(Math.random() * 120)}, ${20 + Math.floor(Math.random() * 120)}, ${30 + Math.floor(Math.random() * 120)}, ${0.8 + Math.random() * 0.2})`;
      ctx.fillText(ch, 0, 0);

      ctx.lineWidth = 0.6;
      ctx.strokeStyle = 'rgba(0,0,0,0.06)';
      ctx.strokeText(ch, 0, 0);
      ctx.restore();
    }

    // add scattered dots
    for (let i = 0; i < 40; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, Math.random() * 1.8, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(0,0,0,${0.05 + Math.random() * 0.2})`;
      ctx.fill();
    }

    ctx.strokeStyle = 'rgba(0,0,0,0.08)';
    ctx.strokeRect(0.5, 0.5, canvas.width - 1, canvas.height - 1);
  }

  function refresh() {
    const s = randomString(length);
    setCode(s);
    setAnswer(s);
    setInput('');
    setAttempts(0);
    // setMessage('');
  }

  useEffect(() => {
    refresh();
  }, []);


  useEffect(() => {
    if (code) drawCaptcha(code);
  }, [code]);

  function handleVerify() {
    setAttempts(prev => prev + 1);
    if (input.trim() === answer) {
      onSuccess();
      setMessage('✅ CAPTCHA verified successfully!');
      setMessageColor('green');
      refresh();
    } else {
      onFailure();
      setMessage('❌ Incorrect CAPTCHA. Try again.');
      setMessageColor('red');
      refresh();
    }
  }

  return (
    <div style={{ display: 'inline-block', fontFamily: 'sans-serif' }}>
      <div style={{ marginBottom: 20 }}>
        <canvas ref={canvasRef} width={width} height={height} style={{ borderRadius: 6, display: 'block' }} />
      </div>

      <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <input
          aria-label="Enter CAPTCHA"
          value={input}
          onChange={e => setInput(e.target.value)}
          placeholder="Type the characters you see"
          style={{ padding: '8px 10px', fontSize: 14, borderRadius: 6, border: '1px solid #ccc', minWidth: 200 }}
        />

        <button onClick={handleVerify} style={{ padding: '8px 12px', borderRadius: 6, cursor: 'pointer' }}>
          Verify
        </button>

        <button onClick={refresh} style={{ padding: '8px 12px', borderRadius: 6, cursor: 'pointer' }}>
          Refresh
        </button>
      </div>
      {message && (
        <div style={{ marginTop: 10, color: messageColor, fontSize: 14, fontWeight: 500 }}>
          {message}
        </div>
      )}

    </div>
  );
}
